module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/admin/view-order-page/view-order-page.component.css
// module id = ./src/app/admin/view-order-page/view-order-page.component.css
// module chunks = main